import React from 'react';
import AccountManager from '../../components/Business/AccountManager';

const DeveloperAccounts = () => {
  return <AccountManager mode="developer" />;
};

export default DeveloperAccounts;
